import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
// import styled from "@emotion/styled";
import {
  IconButton,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserInfo } from "../../data/userInfo";
import { isAdminUser, isAssortmentAnalysisAllStoreUser, isAssortmentAnalysisRailwayStoreOnlyUser, isAssortmentAnalysisOwnStoreOnlyUser, isRailwayDepartmentUser } from "../auth/authUser";

const menuButton = css`
  // background-color: #d9d9d9;
  height: 50px;
  width: 50px;
  padding: 10px;
`;

const designButton = css`
  border: 2px solid #d9d9d9;
  background-color: white;
  color: black;
  border-radius: 20px;
  padding: 5px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const HamburgerMenu: React.FC<{ tenpoCode: string }> = ({ tenpoCode }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const userInfo = getUserInfo();

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    setSelectedItem(index);
  };

  const handleOpenHome = () => {
    navigate("/home", { replace: true });
  }

  const allMenuItems = [
    { name: "個店経営状況（個別）サマリ", url: "/?mode=daily-store-summary", pathname:"/daily-store-summary" },
    { name: "日別管理表", url: "/?mode=daily-management", pathname:"/daily-management" },
    { name: "廃棄検証（PMA）", url: "/?mode=disposal-verification-pma", pathname:"/disposal-verification-pma" },
    { name: "POS-PMA分析_サマリ", url: "/?mode=pos-analysis-summary", pathname:"/pos-analysis-summary" },
    { name: "POS-PMA分析_PMA", url: "/?mode=pos-analysis-pma", pathname:"/pos-analysis-pma" },
    { name: "POS-PMA分析_PMA推移", url: "/?mode=pos-analysis-transition", pathname:"/pos-analysis-transition" },
    { name: "品揃え分析（新上位100単品）", url: "/?mode=assortment-analysis", pathname:"/assortment-analysis" },
  ];

  const menuItems = (() => {
    if (process.env.REACT_APP_MODE !== "cloud-prod" &&
        process.env.REACT_APP_MODE !== "cloud-demo") {
      return allMenuItems;
    }
    if (
      isAdminUser(userInfo) ||
      isRailwayDepartmentUser(userInfo)
    ) {
      return allMenuItems;
    }
    if (isAssortmentAnalysisAllStoreUser(userInfo) ||
        isAssortmentAnalysisRailwayStoreOnlyUser(userInfo) ||
        isAssortmentAnalysisOwnStoreOnlyUser(userInfo)) {
      return allMenuItems.filter(
        (item) => item.name === "品揃え分析（新上位100単品）"
      );
    }
    return allMenuItems.filter(
      (item) => item.name !== "品揃え分析（新上位100単品）"
    );
  })();

  const menuList = (
    <Box sx={{ width: 300, display: 'flex', flexDirection: 'column', height: '100%' }} role="presentation">
      <Box sx={{ p: 1 }}>
        <Grid container>
          <Grid item xs={10}>
            <Typography variant="h6">OFCダッシュボード</Typography>
          </Grid>
          <Grid item xs={2}>
            <IconButton onClick={() => setMenuOpen(false)} size={"small"}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
        {menuItems.map((item, index) => (
          <ListItem key={item.name} disablePadding>
            <ListItemButton
              sx={{ pl: 3 }}
              selected={location.pathname === item.pathname}
              onClick={(event) => {
                handleListItemClick(event, index);
                window.open(item.url + "&tenpocode=" + tenpoCode, "_blank");
              }}
            >
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
        <Button onClick={handleOpenHome} css={designButton}>
          ホーム画面へ戻る
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <IconButton onClick={() => setMenuOpen(true)} css={menuButton}>
        <MenuIcon />
      </IconButton>
      <Drawer
        anchor={"left"}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      >
        {menuList}
      </Drawer>
    </>
  );
};

export default HamburgerMenu;
